import { render } from "./Areas.vue?vue&type=template&id=7ea3640e&scoped=true&lang=html"
import script from "./Areas.vue?vue&type=script&lang=js"
export * from "./Areas.vue?vue&type=script&lang=js"

import "./Areas.vue?vue&type=style&index=0&id=7ea3640e&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea3640e"]])

export default __exports__